import { render, staticRenderFns } from "./Navigation-Component.vue?vue&type=template&id=a60e45fe&scoped=true&"
import script from "./Navigation-Component.vue?vue&type=script&setup=true&lang=js&"
export * from "./Navigation-Component.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./Navigation-Component.vue?vue&type=style&index=0&id=a60e45fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a60e45fe",
  null
  
)

export default component.exports